"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNTESFromAccommodationEffects = exports.AccommodationSchema = void 0;
const z = __importStar(require("zod"));
const serialised_eventr_date_1 = require("./serialised-eventr-date");
const start_or_end_enum_1 = require("./start-or-end-enum");
exports.AccommodationSchema = z.object({
    _id: z.string(),
    rooms: z
        .array(z.object({
        guests: z
            .array(z.object({
            option: z.union([z.string(), z.number().int()]),
        }))
            .optional(),
        checkIn: serialised_eventr_date_1.EventrDateFromStringSchema,
        checkOut: serialised_eventr_date_1.EventrDateFromStringSchema,
        booking_ref: z.string().optional(),
    }))
        .optional(),
    name: z.string(),
    accommodationType: z.string().optional(),
    startOrEnd: start_or_end_enum_1.StartOrEndEnum,
});
/**
 * A ZodEffects that transforms the accommodation data into a UNTES.
 * @param userId The user to find the correct room.
 * @returns The UNTES object.
 */
const UNTESFromAccommodationEffects = (userId) => exports.AccommodationSchema.transform((accommodation) => {
    const selectedRoom = accommodation.rooms.find((room) => room.guests.map((guest) => guest.option).includes(userId));
    return {
        room: selectedRoom,
        ...accommodation,
    };
})
    .superRefine((accommodation, ctx) => {
    if (!accommodation.room) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `No room found for user ${userId}`,
        });
        return z.NEVER;
    }
})
    .transform((accommodation) => {
    return {
        id: accommodation._id,
        date: accommodation.startOrEnd === 'start'
            ? accommodation.room.checkIn
            : accommodation.room.checkOut,
        section: 'accommodation',
        subSection: accommodation.accommodationType,
        primary: accommodation.name,
        ...(accommodation.room.booking_ref
            ? { bookingReference: accommodation.room.booking_ref }
            : {}),
        startOrEnd: accommodation.startOrEnd,
    };
});
exports.UNTESFromAccommodationEffects = UNTESFromAccommodationEffects;
